import { faAngleLeft, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageNav } from "components/PageNav/PageNav";
import React, { FC, useState } from "react";
import { slide as Menu, State } from "react-burger-menu";
import { Link } from "react-router-dom";
import { StickyContainer } from "react-sticky";

export const MainContainer: FC = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleStateChange = (state: State) => {
    setMenuOpen(state.isOpen);
  };

  return (
    <div className="page-container">
      <div className="side-nav-container">
        <Menu
          width={"200px"}
          disableAutoFocus
          customBurgerIcon={<FontAwesomeIcon icon={faBars} />}
          customCrossIcon={<FontAwesomeIcon icon={faAngleLeft} />}
          isOpen={menuOpen}
          onStateChange={(state) => handleStateChange(state)}
        >
          <Link
            id="home"
            className="menu-item"
            to="/"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            id="cv"
            className="menu-item"
            to="/cv"
            onClick={() => setMenuOpen(false)}
          >
            CV
          </Link>
          <Link
            id="blog"
            className="menu-item"
            to="/blog"
            onClick={() => setMenuOpen(false)}
          >
            Blog
          </Link>
        </Menu>
      </div>
      <StickyContainer>
        <div className="main-body-container">
          <PageNav />
          <div className="page-content-container">{props.children}</div>
        </div>
      </StickyContainer>
    </div>
  );
};
